import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveFromBasket2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="remove-from-basket-2"><path d="M8.25 3.75L6.35 8.5M15.75 3.75L17.65 8.5M10.25 20.25H4.75L2.75 8.75H21.25L20.7285 11.7485M14.7019 20.2981L17 18M17 18L19.2981 15.7019M17 18L14.7019 15.7019M17 18L19.2981 20.2981" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconRemoveFromBasket2;
